// COLORIZER_COLOR_LIST Item{
//     name: 'natural',
//     value: 修复和上色都打开用这个提示词
//     aloneValue：单独打开上色用这个提示词
// }

const PROMPT_BEFORE_COLORIZER_AND_RESTORATION = `Remove all scratches, tears, noise, grain, and dust spots from this old photo while preserving the original content and details. 
Repair missing areas, water stains, and mold in photos, filling in damaged areas so that they blend naturally with the surrounding content. 
Enhance the clarity, contrast, and details of photos, colorize this photo to make it`;

const PROMPT_AFTER_COLORIZER = 'Enhance the clarity, contrast, and details of photos, colorize this photo to make it';

export const PROMPT_BEFORE_RESTORATION = `Remove all scratches, tears, noise, grain, and dust spots from this old photo while preserving the original content and details. 
Repair missing areas, water stains, and mold in photos, filling in damaged areas so that they blend naturally with the surrounding content. `;

export const COLORIZER_COLOR_LIST = [
    {
        name: 'natural',
        value: `${PROMPT_BEFORE_COLORIZER_AND_RESTORATION} Natural & Realistic`,
        aloneValue: `${PROMPT_AFTER_COLORIZER} Natural & Realistic`,
    },
    {
        name: 'sepia',
        value: `${PROMPT_BEFORE_COLORIZER_AND_RESTORATION} Sepia-toned with mild color accents`,
        aloneValue: `${PROMPT_AFTER_COLORIZER} Sepia-toned with mild color accents`,
    },
    {
        name: 'vibrant',
        value: `${PROMPT_BEFORE_COLORIZER_AND_RESTORATION} High-contrast vibrant colors`,
        aloneValue: `${PROMPT_AFTER_COLORIZER} High-contrast vibrant colors`,
    },
    {
        name: 'dreamy',
        value: `${PROMPT_BEFORE_COLORIZER_AND_RESTORATION} Dreamy pastel tones`,
        aloneValue: `${PROMPT_AFTER_COLORIZER} Dreamy pastel tones`,
    },
    {
        name: 'muted',
        value: `${PROMPT_BEFORE_COLORIZER_AND_RESTORATION} Muted and desaturated palette`,
        aloneValue: `${PROMPT_AFTER_COLORIZER} Muted and desaturated palette`,
    },
    {
        name: 'painterly',
        value: `${PROMPT_BEFORE_COLORIZER_AND_RESTORATION} Painterly colorization`,
        aloneValue: `${PROMPT_AFTER_COLORIZER} Painterly colorization`,
    },
    {
        name: 'cinematic-colorizer',
        value: `${PROMPT_BEFORE_COLORIZER_AND_RESTORATION} Cinematic color grading`,
        aloneValue: `${PROMPT_AFTER_COLORIZER} Cinematic color grading`,
    },
    {
        name: 'b-w',
        value: `${PROMPT_BEFORE_COLORIZER_AND_RESTORATION} black & white color`,
        aloneValue: `${PROMPT_AFTER_COLORIZER} black & white color`,
    },
    {
        name: 'cold',
        value: `${PROMPT_BEFORE_COLORIZER_AND_RESTORATION} Scandinavian muted minimalism`,
        aloneValue: `${PROMPT_AFTER_COLORIZER} Scandinavian muted minimalism`,
    },
    {
        name: 'ethereal',
        value: `${PROMPT_BEFORE_COLORIZER_AND_RESTORATION} Ethereal glow with light leaks`,
        aloneValue: `${PROMPT_AFTER_COLORIZER} Ethereal glow with light leaks`,
    },
    {
        name: 'glow-colorizer',
        value: `${PROMPT_BEFORE_COLORIZER_AND_RESTORATION} Ethereal glow with soft light diffusion`,
        aloneValue: `${PROMPT_AFTER_COLORIZER} Ethereal glow with soft light diffusion`,
    },
    {
        name: 'bright',
        value: `${PROMPT_BEFORE_COLORIZER_AND_RESTORATION} Joyful bright and lively colors`,
        aloneValue: `${PROMPT_AFTER_COLORIZER} Joyful bright and lively colors`,
    },
    {
        name: 'pink-colorizer',
        value: `${PROMPT_BEFORE_COLORIZER_AND_RESTORATION} Romantic soft pinks and creams`,
        aloneValue: `${PROMPT_AFTER_COLORIZER} Romantic soft pinks and creams`,
    },
    {
        name: 'bollywood',
        value: `${PROMPT_BEFORE_COLORIZER_AND_RESTORATION} Bollywood vibrant tones`,
        aloneValue: `${PROMPT_AFTER_COLORIZER} Bollywood vibrant tones`,
    },
    {
        name: 'pop-art-colorizer',
        value: `${PROMPT_BEFORE_COLORIZER_AND_RESTORATION} Surreal pop-art colors`,
        aloneValue: `${PROMPT_AFTER_COLORIZER} Surreal pop-art colors`,
    },
    {
        name: 'neon-colorizer',
        value: `${PROMPT_BEFORE_COLORIZER_AND_RESTORATION} Cyberpunk neon accents`,
        aloneValue: `${PROMPT_AFTER_COLORIZER} Cyberpunk neon accents`,
    },
];
